import {
  createLazyContext,
  useLazyContextProvider,
  useRequiredContext,
} from "@redotech/react-util/context";
import { useHasPermission } from "@redotech/redo-merchant-app-common/auth/permissions-context";
import { RedoMerchantClientContext } from "@redotech/redo-merchant-app-common/client/context";
import { getConversationTagsOfTeam } from "@redotech/redo-merchant-app-common/client/conversation-tags";
import { TeamContext } from "@redotech/redo-merchant-app-common/team";
import { ConversationTagWithId } from "@redotech/redo-model/conversation";
import { SupportPermissions } from "@redotech/redo-model/permissions";
import { memo, ReactNode } from "react";

export const ConversationTagsContext =
  createLazyContext<ConversationTagWithId[]>();

export const ConversationTagsService = memo(function ConversationTagsService({
  children,
}: {
  children: ReactNode | ReactNode[];
}) {
  const client = useRequiredContext(RedoMerchantClientContext);

  const team = useRequiredContext(TeamContext);

  const hasSupportPermission = useHasPermission(
    SupportPermissions.VIEW_SUPPORT,
  );
  const loadState = useLazyContextProvider(async (signal) => {
    if (!hasSupportPermission) {
      return [];
    }
    const teamTags = await getConversationTagsOfTeam(
      client,
      { teamId: team._id },
      signal,
    );
    const tagIds = teamTags.map((tag) => {
      return {
        tagId: tag._id,
        name: tag.name,
        pillTheme: tag.pillTheme,
        source: tag.source,
        tagGroupId: tag.tagGroupId,
      };
    });
    return tagIds.sort((a, b) => a.name.localeCompare(b.name));
  });

  return (
    <ConversationTagsContext.internalContext.Provider value={loadState}>
      {children}
    </ConversationTagsContext.internalContext.Provider>
  );
});
